import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

import { SelectedProduct } from "@/types/Product"

import { createInitialState } from "./initialStateHelper"
import { State, ImmerStateCreator, SkipassStore } from "./types"

export type { SkipassStore }

export const initialState: State = createInitialState()

const skipasStoreStateCreator: ImmerStateCreator<SkipassStore> = immer(
  (set) => ({
    ...initialState,
    setHostConfig: (hostConfig) => {
      set((state) => {
        state.hostConfig = hostConfig
      })
    },

    clearProducts: () => {
      set((state) => {
        state.selectedProducts = []
      })
    },

    clearSelectionState: () => {
      set((state) => {
        state.selectedProducts = []
      })
    },

    incrementProduct: (productInfo: Omit<SelectedProduct, "quantity">) => {
      set((state) => {
        const id = productInfo.productPriceId
        const index = state.selectedProducts.findIndex(
          (p) => p.productPriceId === id
        )

        if (index !== -1) {
          state.selectedProducts[index].quantity += 1
        } else {
          state.selectedProducts.push({
            ...productInfo,
            quantity: 1,
          } as SelectedProduct)
        }
      })
    },

    setArrivalDateHasBeenSet: () => {
      set((state) => {
        state.hasArrivalDateBeenSet = true
      })
    },

    decrementProduct: (productPriceId: string) => {
      set((state) => {
        const index = state.selectedProducts.findIndex(
          (p) => p.productPriceId === productPriceId
        )

        if (index === -1) return

        const currentQty = state.selectedProducts[index].quantity

        if (currentQty <= 1) {
          state.selectedProducts.splice(index, 1)
        } else {
          state.selectedProducts[index].quantity -= 1
        }
      })
    },
  })
)

export const skipassStoreCreator = () =>
  create<SkipassStore>()(skipasStoreStateCreator)

export const useSkipassStore = skipassStoreCreator()
